module.exports = __webpack_public_path__ + "static/img/116_TO8_1645_og.75380a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/116_TO8_1645_og.jpg
// module id = 8kGp
// module chunks = 0